module.exports = __webpack_public_path__ + "77787333af8eca0b5a2b27444df0a7f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/how-it-works.svg
// module id = ./src/how-it-works.svg
// module chunks = 1